import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {FormArray} from '@angular/forms';
import {WaConversionsEvent, WaSettings} from './wa-settings-form';
import {Step} from '../../../../../../../shared/models';
import isEmpty from 'lodash/isEmpty';
import {SendTemplateService, WaBusinessAccounts} from '../../actions/send-template/send-template.service';
import {tap} from 'rxjs/operators';
import {swalMini} from '../../../../../../../shared/utils/utils';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-whats-app-settings',
    templateUrl: './whats-app-settings.component.html',
    styleUrls: ['./whats-app-settings.component.scss']
})
export class WhatsAppSettingsComponent implements OnInit, OnChanges {

    readonly EVENT_LIMITS = {
        overflow: 1,
        min: 1
    };

    readonly CUSTOM_DATA_LIMITS = {
        overflow: 1
    };

    @ViewChild('slider') slider: ElementRef;
    @ViewChild('confirmationDialog') dialogTemplate: TemplateRef<any>;

    @Input() step: Step | string;
    @Input() isDisabled: boolean;
    @Output() update: EventEmitter<{ [key: string]: any }> = new EventEmitter();
    @Output() close = new EventEmitter();

    public isOpen = false;
    public conversionForm: FormArray;
    public waBusinessAccounts: WaBusinessAccounts[] = undefined;
    public waBusinessAccountsFiltered: WaBusinessAccounts[] = [];

    constructor(private sendTemplateService: SendTemplateService,
                private dialog: MatDialog) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.step) {
            const metadata = this.step['metadata'] || {};
            this.conversionForm = WaSettings.toForm(metadata, this.isDisabled);
        }
    }

    ngOnInit(): void {
        this.sendTemplateService.get_accounts().pipe(
            tap(data => this.waBusinessAccounts = data),
            tap(data => this.waBusinessAccountsFiltered = data.slice())
        ).subscribe();
    }


    public closeOverlay(): void {
        this.isOpen = false;
        this.close.emit();
    }

    public saveSettings(): void {
        if (!this.isDisabled) {
            return;
        }

        this.conversionForm.markAllAsTouched();

        if (!this.conversionForm.valid) {
            swalMini({title: 'Please fill all required fields', type: 'error'});
            return;
        }

        this.isOpen = false;
        this.update.emit(WaSettings.setConversion(this.conversionForm.getRawValue()));
    }

    public wabaFilter(element: HTMLInputElement) {
        const filterValue = element.value;
        if (isEmpty(this.waBusinessAccounts)) {
            this.waBusinessAccountsFiltered = [];
            return;
        }
        this.waBusinessAccountsFiltered = this.waBusinessAccounts?.filter(option => option.wabaName.includes(filterValue));
    }

    public waBusinessAccountsDisplay(id: string): string {
        if (this.waBusinessAccounts && id) {
            return this.findWaBusinessAccounts(id).wabaName;
        }

        return '';
    }

    private findWaBusinessAccounts(id: string): WaBusinessAccounts {
        return this.waBusinessAccounts?.find(x => x.wabaId === id);
    }

    public onDeleteEvent(index: number, events: FormArray) {
        if (!this.isDisabled) {
            return;
        }
        if (events.length === this.EVENT_LIMITS.min) {
            swalMini({title: 'At least event is required', type: 'error'});
            return;
        }
        events.removeAt(index);
    }

    public onAddNewEvent(events: FormArray) {
        if (!this.isDisabled) {
            return;
        }
        const waConversionsEvent: WaConversionsEvent = {
            eventName: '',
            customData: {}
        };
        events.push(WaSettings.eventFormTemplate(waConversionsEvent, this.isDisabled));
    }

    public onDeleteCustomData(index: number, customData: FormArray) {
        if (!this.isDisabled) {
            return;
        }
        customData.removeAt(index);
    }

    public onAddCustomData(customData: FormArray) {
        if (!this.isDisabled) {
            return;
        }

        customData.push(WaSettings.customDataFormTemplate('', '', this.isDisabled));
    }

    public onReset() {
        this.dialog.open(this.dialogTemplate, {
            width: '530px',
            height: '160px',
            disableClose: true,
        });
    }

    public onConfirmReset() {
        this.dialog.closeAll();
        this.conversionForm = WaSettings.toForm({}, this.isDisabled);
        this.isOpen = false;
        this.update.emit(undefined);
    }

    public onResetCancel() {
        this.dialog.closeAll();
    }
}
